import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const BluetoothConnected: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'm7 7 10 10-5 5V2l5 5L7 17' }],
    ['line', { x1: '18', x2: '21', y1: '12', y2: '12' }],
    ['line', { x1: '3', x2: '6', y1: '12', y2: '12' }],
  ],
];

export default BluetoothConnected;
